import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { UserManagerWrap } from "./styles";
import { Button } from "../../BaseComponents";
import { Select } from "antd";
import { useReactTable, getCoreRowModel } from "@tanstack/react-table";
import { alertActions, UserActions } from "../../Redux";

// const AdminHeader = ({ toggleEditAdmins }) => (
//   <section style={{ display: "flex" }}>
//     Admin
//     <Button size="small" type="ghost" label="Edit" onClick={toggleEditAdmins} />
//   </section>
// );

const UserManager = () => {
  const dispatch = useDispatch();
  const user_group_raw = useSelector((state) => state.user.user_group || {});
  const user_group = useMemo(() => Object.values(user_group_raw), [user_group_raw]);
  const email = useSelector((state) => state.user.email || {});

  const [editAdmins, setEditAdmins] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempUserData, setTempUserData] = useState(user_group);

  useEffect(() => {
    setTempUserData(user_group);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, [user_group]);

  const handleAdminChange = useCallback((index, value) => {
    setTempUserData((prev) => prev.map((user, i) => (i === index ? { ...user, group_admin: value === true } : user)));
  }, []);

  const saveChanges = useCallback(() => {
    setLoading(true);

    const hasGroupAdmin = tempUserData.find((user) => user.group_admin);
    if (!hasGroupAdmin) {
      dispatch(alertActions.info("There has to be at least one admin in your group", 4));
      setLoading(false);
      return;
    }

    const current_user = tempUserData.find((user) => user.email == email);

    if (current_user.group_admin === false) {
      dispatch(alertActions.info("You cannot remove yourself as an admin", 4));
      setLoading(false);
      return;
    }

    const temp_user_data = tempUserData.reduce(
      (acc, user) => {
        acc[user.user_id] = user;
        return acc;
      },
      { group_id: tempUserData[0]?.group_id }
    );

    dispatch(UserActions.updateGroupAdmins(temp_user_data));
    setEditAdmins(false);
    setLoading(false);
  }, [dispatch, tempUserData]);

  const cancelEdit = () => {
    setTempUserData(user_group);
    setEditAdmins(false);
  };

  const columns = useMemo(
    () => [
      { header: "User", accessorKey: "email", cell: (info) => info.getValue() },
      {
        header: "Admin",
        accessorKey: "group_admin",
        cell: (info) => {
          const value = info.getValue();
          const rowIndex = info.row.index;
          return (
            <section style={{ width: 250 }}>
              {editAdmins ? (
                <Select size="small" style={{ width: 70 }} value={value ? "Yes" : "No"} onChange={(e) => handleAdminChange(rowIndex, e)}>
                  <Select.Option value={true}>Yes</Select.Option>
                  <Select.Option value={false}>No</Select.Option>
                </Select>
              ) : value ? (
                "Yes"
              ) : (
                "No"
              )}
            </section>
          );
        },
      },
    ],
    [editAdmins, handleAdminChange]
  );

  const table = useReactTable({
    data: tempUserData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <UserManagerWrap>
      <section className="user-admin">
        <Button styles={{ width: 72 }} type="secondary" size="small" disabled={loading} label={editAdmins ? "Cancel" : "Edit Users"} onClick={editAdmins ? cancelEdit : () => setEditAdmins(true)} />{" "}
        <Button type="secondary" size="small" label="Save Changes" loading={loading} disabled={!editAdmins || loading} onClick={saveChanges} />
      </section>

      <table className="user-group-table">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>{header.isPlaceholder ? null : header.column.columnDef.header}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>{cell.column.columnDef.cell(cell.getContext())}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </UserManagerWrap>
  );
};

export { UserManager };
